import { cn } from '@/lib/utils';

import { CrawlingBorderProps } from '../types';

export function CrawlingBorder({
    isActive,
    children,
    className,
}: CrawlingBorderProps) {
    return (
        <div
            className={cn(
                'relative rounded-xl',
                // The padding creates the "border" space
                isActive ? 'p-[2px]' : 'p-0',
                className,
            )}
        >
            {/* Animated gradient - sits behind everything */}
            {isActive && (
                <div
                    className={cn(
                        'absolute inset-0 rounded-xl',
                        'bg-[conic-gradient(from_var(--gradient-angle),transparent_0%,hsl(var(--primary))_10%,transparent_20%)]',
                        'animate-border-spin',
                    )}
                    style={
                        { '--gradient-angle': '0deg' } as React.CSSProperties
                    }
                />
            )}

            {/* Inner container - covers the gradient except for the 2px border */}
            <div
                className={cn(
                    'relative rounded-[10px] bg-background h-full',
                    !isActive && 'rounded-xl',
                )}
            >
                {children}
            </div>
        </div>
    );
}
